import { apiPost } from '../client';
import type { BillingInformationRequest, BillingInformationResponse } from '../types/billing';

export function submitBilling(body: BillingInformationRequest): Promise<BillingInformationResponse> {
  return apiPost<BillingInformationRequest, BillingInformationResponse>('Billing/Submit', body);
}
